import { pixels_to_km } from "./constants";
import { totalRad } from "./crank";
import { addEvent } from "./events";
import { direction } from "./message";
import { IUnit, removeUnit, units } from "./units";

const impact = new Audio('artillery/sounds/impact.mp3');
const fire = new Audio('artillery/sounds/fire.mp3');

impact.volume = 1;
fire.volume = 0.5;

const gravity = 1.5;
const power = 33;


export const DEGTORAD = Math.PI / 180
export const RADTODEG = 180 / Math.PI

export class Shell{
    x: number;
    y: number;
    z: number;
    
    y_angle_rad: number; 
    x_angle_rad: number; 
    power: number;
    
    x_v: number;
    z_v: number;
    xv_velocity: number;  //velocity along xy axis
    y_velocity: number; //velocity up/down

    destroyed: boolean = false

    constructor(y_angle_rad: number, x_angle_rad: number, x: number, y:number, z:number, power:number) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.y_angle_rad = y_angle_rad;
        this.x_angle_rad = x_angle_rad;
        this.power = power;

        this.x_v = Math.cos(this.y_angle_rad);
        this.z_v = Math.sin(this.y_angle_rad);
        this.xv_velocity = Math.cos(x_angle_rad) * power; 
        this.y_velocity = Math.sin(x_angle_rad) * power;

        fire.currentTime = 0;
        fire.play()
    }

    step(delta:number) {
        if(this.destroyed){
            return;
        }
        this.y_velocity -= gravity * delta * 0.5;

        this.x += this.x_v * this.xv_velocity * delta;
        this.z += this.z_v * this.xv_velocity * delta;

        this.y += this.y_velocity * delta;

        this.y_velocity -= gravity * delta * 0.5;

        if (this.y < 0){
            this.impact();
        }
    }

    draw(ctx:CanvasRenderingContext2D){
        if(this.destroyed){
            return;
        }
        ctx.beginPath();
        ctx.arc(this.x, this.z, Math.sqrt(this.y), 0, 360)
        ctx.stroke();
    }

    impact(){
        this.destroyed = true;
        //Increase explosion size as target gets further away
        // const range = Math.cbrt((this.x - 400) ** 2 + (this.z - 400) ** 2) + 10
        const range = 20;

        let lowest_dist = 99999;
        let closest_unit:IUnit|null = null;

        for(const unit of units){
            const u = unit.unit;
            const dist = Math.sqrt((this.x - u.x) ** 2 + (this.z - u.z) ** 2)
            if(dist < lowest_dist){
                lowest_dist = dist;
                closest_unit = unit;
            }
            if(dist < range){
                removeUnit(unit);
                // addEvent("Hit target " + target.name + "! Accuracy: " + ((1-(dist/range))*100).toFixed(0) + "/100")
            }
        }

        const hit = lowest_dist < range;
        const marker = new Marker(this.x, this.z, hit);
        markers.push(marker);
        setTimeout(() => {
            markers.splice(markers.indexOf(marker), 1)
        }, 3000);

        impact.play()

        if(lowest_dist < range || !closest_unit){
            return;
        }


        const km_dist = distToKM(lowest_dist)
        const m_dist = km_dist * 1000 //we want 1.sf ish
        
        const x_diff = (this.x - closest_unit.unit.x)
        const z_diff = (this.z - closest_unit.unit.z)
        const dir = direction(x_diff, z_diff)

        // const msg = "target " +closest_target.name + " : Explosion hit " + Number(m_dist.toPrecision(2)).toFixed(0) + "m " + dir

        // addEvent(msg)
    }
}

export class Marker{
    x:number;
    y:number;
    hit: boolean;
    constructor(x:number, y:number, hit:boolean){
        this.hit = hit;
        this.x = x;
        this.y = y;
    }
    
    draw(ctx:CanvasRenderingContext2D){
        ctx.strokeStyle = this.hit ? "green" : "blue"
        ctx.beginPath();
        ctx.moveTo(this.x - 10, this.y - 10);
        ctx.lineTo(this.x + 10, this.y + 10);
        ctx.moveTo(this.x - 10, this.y + 10);
        ctx.lineTo(this.x + 10, this.y - 10)
        ctx.stroke();
        ctx.strokeStyle = "black"
    }
}

export const markers : Marker[] = [];

function generate_table(){
    // We want to do 
    // create ~40 rows of data with 
    // range, y - angle,  time in air, how much angle to adjust for elevation change, 


    // time in air  =2 * (y_velocity / gravity)  + hdiff/y_velocity  (not bothering with derivatives)
    // peak = (time * y_v ) / 2
    // distance = time * x_v

    //now we know that, can we work it out from distance

    // distance = ( 2 * y_v / gravity) * x_v

    // distance = ( 2 * sin(a) / gravity ) * cos(a)

    // distance = 2sin(a)cos(a) / gravity

    // distance * gravity = sin(2a)

    //claude simplifies to:
    //angle = 1/2 * sin-1(distance*gravity)

    let text = ""

    for(let i = 0; i < 100; i++){
        const distance = i * pixels_to_km / 5;
        console.log(distance, distToKM(distance))
        const angle = 0.5 * Math.asin(distance*gravity/Math.pow(power, 2))
        const time = 2 * power * Math.sin(angle) / gravity
        //estimate height change angles

        const downforce = power * Math.sin(angle)
        const height_change = 1
        const extra_time = height_change / downforce
        const extra_forward = extra_time * (Math.cos(angle) * power)

        // console.log(distance, angle * RADTODEG, time)
        text = text + distToKM(distance).toFixed(1) + "," + (angle * RADTODEG).toFixed(2) + "," + time.toFixed(1) +"," + distToKM(extra_forward*100).toFixed(0) + "\n"
    }

    console.log(text)
}

function distToKM(dist:number){
    //Converts the distance to KM for immersion
    //Current rate - 40 = 1km
    return dist / pixels_to_km
}

generate_table();